interface IWheelConstants {
  KEY_WHEEL_SESSION_STORAGE: string;
  KEY_SHOWN_WHEELS: string;
}

export const WHEEL_CONSTANTS: IWheelConstants = {
  KEY_WHEEL_SESSION_STORAGE: '_sberlead_wheel_',
  KEY_SHOWN_WHEELS: '_clickStream_shown_wheels_',
};